import * as actionTypes from 'redux/actionTypes/Index';
import { campaignInitialState } from './InitialState';
import { IActionType } from 'interfaces/Index';

const initialState = { ...campaignInitialState };
export default function campaignReducer(
  state = initialState,
  action: IActionType
) {
  switch (action.type) {
    case actionTypes.GET_CAMPAIGNS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        isError: false,
        isCampaignFetched: false,
        isCampaignFetchedError: false,
        isCampaignCreated: false,
        isCampaignUpdated: false
      });
    }
    case actionTypes.GET_CAMPAIGNS_FAIL: {
      return Object.assign({}, state, {
        isLoading: true,
        error: true,
        isError: action.error,
        isCampaignFetched: false,
        isCampaignFetchedError: true,
      });
    }

    case actionTypes.GET_CAMPAIGNS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        error: false,
        isError: null,
        isCampaignFetched: true,
        isCampaignFetchedError: false,
        campaigns: (action.payload! as any).campaigns,
        pagination: (action.payload! as any).pagination,
      });
    }

    case actionTypes.CREATE_CAMPAIGN_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        isError: false,
        isCampaignCreated: false,
      });
    }
    case actionTypes.CREATE_CAMPAIGN_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        isError: true,
        isCampaignCreated: false,
      });
    }

    case actionTypes.CREATE_CAMPAIGN_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        isError: false,
        isCampaignCreated: true,
      });
    }

    case actionTypes.UPDATE_CAMPAIGN_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        isError: false,
        isCampaignUpdated: false
      });
    }
    case actionTypes.UPDATE_CAMPAIGN_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        isError: true,
        isCampaignUpdated: false
      });
    }

    case actionTypes.UPDATE_CAMPAIGN_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        isError: false,
        isCampaignUpdated: true
      });
    }
    default:
      return state;
  }
}
